import { StudentApplicationEvent } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetParams {
  studentApplicationId: string;
}

const { useFind: useStudentApplicationEvents } = getCRUDHooks<StudentApplicationEvent>({
  entityName: 'studentApplicationEvents',
  find: ({ studentApplicationId }: GetParams) =>
    clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.id(studentApplicationId)
      .events.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useStudentApplicationEvents };
